export default [
    {
        path: '/localguide',
        name: 'localguide',
        component: () => import('VIEWS/Localguide.vue')
    }
]